/* eslint-disable prettier/prettier */
import {
  getRolesPermisosYGrupos,
  getRoles,
  insertRol,
  updateRol,
  updateStatusRol,
  GetRolesByIdRol,
} from "../apis";
import axios from "axios";
import toast from "react-hot-toast";
import {
  getroles,
  closeAlert,
  setRolAdd,
  updateRolSuccess,
  updateStatusSuccess,
  isLoadingRoles,
} from "./rolesSlice";

import { store } from "../store";

export function InformacionInicialRoles(dispatch) {
  const token = store.getState().login.token;
  dispatch(isLoadingRoles(true));
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .get(getRolesPermisosYGrupos(), header)
    .then((response) => {
      dispatch(getroles(response.data.data));
      dispatch(isLoadingRoles(false));
    })
    .catch((error) => {
      dispatch(isLoadingRoles(false));
    });
}

export function InsertarRol(dispatch, data) {
  const token = store.getState().login.token;
  let id = toast.loading("Procesando, por favor espere...");
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .post(insertRol(), data, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Error") {
        toast.error("Error al agregar el rol");
      }
      if (response.data.code === "Ok") {
        dispatch(setRolAdd(response.data.data));
        toast.success("Éxito al agregar el rol");
      }
    })
    .catch((error) => {});
}

export function ActualizarRol(dispatch, data) {
  const token = store.getState().login.token;
  let id = toast.loading("Procesando, por favor espere...");
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .put(updateRol(), data, header)
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Error") {
        toast.error("Error al actualizar el rol");
      }
      if (response.data.code === "Ok") {
        dispatch(updateRolSuccess(data));
        toast.success("Éxito al actualizar el rol");
      }
    })
    .catch((error) => {});
}

export function UpdateStatusRol(dispatch, data, activo, userId) {
  const token = store.getState().login.token;
  let id = toast.loading("Procesando, por favor espere...");
  const header = {
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };
  axios
    .put(
      `${updateStatusRol()}?idModificar=${data.idRolUsuario}&activo=${activo}&userid=${userId}`,
      data,
      header
    )
    .then((response) => {
      toast.remove(id);
      if (response.data.code === "Error") {
        toast.error("Error al modificar el estatus del rol");
      }
      if (response.data.code === "Ok") {
        data.activo = activo;
        dispatch(updateStatusSuccess({ ...data }));
        toast.success("Éxito al modificar el estatus del rol");
      }
    })
    .catch((error) => {
      toast.remove(id);
      toast.error("Error al modificar el estatus del rol");
    });
}

export const getPermisosRoles = (idRol) => async (dispatch) => {
  const token = store.getState().login.token;
  const usuario = store.getState().login.usuario;
  let id = toast.loading("Procesando solicitud, por favor espere...");
  try {
    const header = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(GetRolesByIdRol().concat("?rolid=").concat(idRol), header);
    toast.remove(id);
    return response.data.data;
  } catch (error) {
    console.error("Error en la petición:", error);
    toast.remove(id);
    toast.error("Ocurrio un error ");
    return true;
  }
};
